import styled from "styled-components";

export const ErrorContainer = styled.div`
  font-size: 2rem;
  color: red;
`;
